module.exports = __webpack_public_path__ + "img/github.5dbb20ef.svg";